import styled from 'foundations-theming/utils';
import { useLayoutEffect, useRef } from 'react';
import { usePopOutEditorState } from '../hooks/usePopOutEditorState';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { jsx as _jsx } from "react/jsx-runtime";
const ModalInner = styled.div.withConfig({
  displayName: "EditorModal__ModalInner",
  componentId: "sc-67ic2t-0"
})(["block-size:100%;.popout-editor-teleporter{position:relative;width:100%;block-size:100%;display:flex;flex-direction:column;color:", ";}"], ({
  theme
}) => theme.color['fill-accent-neutral-default']);
export const EditorModal = ({
  editorKey = 'default'
}) => {
  const targetRef = useRef(null);
  const {
    isOpen,
    key,
    setRef
  } = usePopOutEditorState(editorKey);
  useLayoutEffect(() => {
    const shouldUpdateRef = isOpen && key === editorKey;
    if (shouldUpdateRef) {
      setRef(targetRef.current);
    }
    return () => {
      if (shouldUpdateRef) setRef(null);
    };
  }, [isOpen, setRef, key, editorKey]);
  if (isOpen) {
    return /*#__PURE__*/_jsx(Modal, {
      use: "lightbox",
      children: /*#__PURE__*/_jsx(ModalInner, {
        children: /*#__PURE__*/_jsx("div", {
          ref: targetRef
        })
      })
    });
  } else {
    return null;
  }
};
EditorModal.displayName = 'EditorModal';